import React, {useEffect, useState} from 'react';
import { Auth as AWSAuth } from 'aws-amplify';
import { AutoLogout } from './auto-logout';

/**
 * Component used with the AWS Amplify Authenticator to provide
 * A&A to the app.
 * The data structure is what was used by the azure msaal component previously
 * and we retain it here for backward compatibility with dependent components
 * and our Auth.dev component.
 */


/**
 * useAuth is used in various components throughout the app. This version
 * simple sets the values within the IAuthContext type.
 */
export const useAuth = () => {
      
  const [attributes, setAttributes] = useState<Record<string,any> | null>(null);

  const handleSignOut = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    try {
      await AWSAuth.signOut();
      // Perform any other actions needed after sign out, e.g. update state or redirect
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };
  
  useEffect(() => {
    const getCurrentUserAttributes = async () => {
      try {
        const user = await AWSAuth.currentAuthenticatedUser();
        const userAttributes = user?.attributes;
        setAttributes(userAttributes);
      } catch (error) {
        console.error('Error getting user attributes:', error);
      }
    };	
    getCurrentUserAttributes();
  }, []); // Empty dependency array to run this effect only once, on component mount

  const role = attributes ? attributes['custom:role'] : 'none';

  const name = attributes ? attributes['name'] : 'Dashboard User';

  const email = attributes ? attributes['email'] : 'none';

  const al = AutoLogout();
  
  return ({
    authenticatedState: "authed",
    accountInfo: {
	    account:
	    {
		name: name,
		idToken:
		{
		    emails: email
		},
		idTokenClaims: {
		    jobTitle: "Dashboard User"
		}
	    }
	},
    signOut: () => handleSignOut,
    userRole: role
    });
};

export interface CompProps {
    children: React.ReactNode
}

/**
 * The top-level index.tsx uses the Auth component. Below is the no-op version.
 */
export const Auth: React.FC<CompProps> = props =>
    <>{props.children}</>;
